module.exports = __webpack_public_path__ + "img/5.0b0af31f.jpg";